import React from 'react';
import DOMPurify from 'dompurify';

export type EmailBodyProps = {
    html: string
}

const EmailBody = ({ html }: Readonly<EmailBodyProps>) => (
    <div
        id="email-body"
        className="text-break"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}
    />
);

export default EmailBody;